import { InsuredGoods } from 'app/shared/components/spb-insured/spb-insured';

export enum Accessibility {
  PROFESSIONAL = 'PROFESSIONAL',
  INDIVIDUAL = 'INDIVIDUAL'
}

export enum CoversDisplayMode {
  MOBILE = 'mobile',
  DESKTOP = 'desktop'
}

export class CoverItem {
  title: string;
  iconURL: string;
  text: string;
  agent: string;
}

export class ExtraItem {
  title: string;
  iconURL: string;
}

export interface Offer {
  code: string;
  title: string;
  description: string;
  covers: CoverItem[];
  extras: ExtraItem[];
  showAmount: boolean;
  contribution: string;
  IPIDUrl: string;
  IPIDUrlTitle: string;
  badgeURL: string;
  eurTaxInclAmount: number;
  coverTitle: string;
  coverDetails: string;
  extraTitle: string;
  extraIconURL: string;
  extraDetails: string;
  documents: any;
  isSelected?: boolean;
  accessibility: Accessibility;
}

export interface IProducts {
  insuredGoods?: InsuredGoods;
  rules?: {};
  inputTypes?: {};
  cmsContent?: {
    insuredGoodsEntities: {};
    includingTaxes: string;
    excludingTaxes: string;
    total: string;
  };
  isReady: boolean;
}

export const initialState = {
  offerDocuments: {
    loading: false,
    documentsByOffer: [],
    offerDocUrl: {},
    errors: {}
  },
  selectedOffer: {} as Offer,
  loading: false,
  errorMessage: '',
  docUrl: {} as { [code: string]: string },
  pageMarketing: undefined as string,
  contextSales: {} as any,
  products: {
    isReady: false
  } as IProducts ,
  signCertifiedDocuments: {
    loading: false,
    documentsByOffer: [],
    offerDocUrl: {},
    errors: {}
  },
};

export type CorporateState = Readonly<typeof initialState>;
